import type { Dict } from "../core.js";
import type { feedback as vi } from "../vi/feedback.js";

export const feedback: Dict<typeof vi> = {
  movedToSupport: "Customer support tickets are now handled in « Support » (all apps). This page only shows the OLD bube-shop-staff store, which nothing writes to anymore.",
  openSupport: "Open Support →",
  "tab.all": "All",
  loadListFailed: "Couldn't load the feedback list.",
  noteSaveFailed: "Couldn't save the note.",
  title: "Customer feedback",
  introBefore: "Titles and excerpts have ",
  introStrong: "personal information redacted",
  introAfter: " before they are stored. The hub doesn't keep the full text — click « Open in source app » to see it.",
  oldestOpen: "Oldest open ticket",
  summaryAllAppsBefore: "The four tiles above count ",
  summaryAllAppsStrong: "all apps",
  summaryAllAppsAfter: " — only the list below is filtered by the selected app.",
  emptyTitle: "No tickets in this status.",
  emptyBefore: "This means « no tickets », ",
  emptyStrong: "not",
  emptyAfter: " « the hub couldn't read » — sources that couldn't be read are listed below.",
  "col.source": "Source",
  "col.title": "Title (redacted)",
  "col.status": "Status",
  "col.submittedAt": "Submitted",
  "col.notes": "Notes",
  nativeStatusTitle: "Source calls it: {status}",
  note: "Note",
  openInSourceApp: "Open in source app",
  noteLabel: "Internal note for « {title} » — NOT sent to the customer",
  saveNote: "Save note",

  loadDetailFailed: "Couldn't load this feedback.",
  backToList: "← Feedback",
  nativeStatus: " (source calls it « {status} »)",
  submittedAt: " · submitted {at}",
  excerpt: "Excerpt (redacted)",
  hubKeepsOnly: "The hub keeps only the title and an excerpt, both with personal information redacted.",
  fullInSourceApp: " The full version is in the source app.",
  internalNotes: "Internal notes ({count})",
  noNotesBefore: "No notes yet. Notes here are ",
  noNotesStrong: "not",
  noNotesAfter: " sent to the customer.",
  addNoteLabel: "Add a note — NOT sent to the customer",
  noReplyV1:
    "The hub has no way to reply to customers in V1 — replying is an outbound action and needs approval and a revocation path before it opens.",
};
